import * as $ from "jquery";

export type HtmlTableArray = string[][]; // one row per outer array and an array with cell-values inside


export class WebHelper {
    public htmlTableToArray(tableID: string): HtmlTableArray {
        if (tableID[0] !== "#")
            tableID = "#" + tableID;
        let rows: HtmlTableArray = [];
        $(tableID + " tr").each((i, value) => {
            let row = $(value);
            let cellValues = [];
            row.find("td").each((i, value) => {
                cellValues.push($(value).text());
            });
            rows.push(cellValues);
        });
        return rows;
    }

    public addParamToUrl(urlStr: string, key: string, value: string, overwrite: boolean = false) {
        if (!value)
            value = "1";
        var start = urlStr.indexOf('?');
        if (start !== -1 && urlStr.indexOf(key + '=') !== -1) {
            if (!overwrite)
                return urlStr // param already exists
            var search = this.escapeRegex(key + '=');
            urlStr = urlStr.replace(new RegExp(search + '[^&]*(&|$)'), ''); // remove it and add it to the end of the url
            urlStr = urlStr.replace(/(\?|&)$/, '');
        }
        var queryParam = urlStr.indexOf('?') !== -1 ? '&' : '?';
        return urlStr + queryParam + key + '=' + value;
    }

    public escapeRegex(str: string) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
}